import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.77168 4.16666C7.14172 2.72897 8.4468 1.66666 10 1.66666C11.5532 1.66666 12.8583 2.72897 13.2283 4.16666H16.6667C17.1269 4.16666 17.5 4.53975 17.5 4.99999C17.5 5.46023 17.1269 5.83332 16.6667 5.83332H15.8333V15.8333C15.8333 17.214 14.714 18.3333 13.3333 18.3333H6.66667C5.28595 18.3333 4.16667 17.214 4.16667 15.8333V5.83332H3.33333C2.8731 5.83332 2.5 5.46023 2.5 4.99999C2.5 4.53975 2.8731 4.16666 3.33333 4.16666H6.77168ZM8.5563 4.16666C8.84448 3.66849 9.3831 3.33332 10 3.33332C10.6169 3.33332 11.1555 3.66849 11.4437 4.16666H8.5563ZM8.33333 8.33332C8.79357 8.33332 9.16667 8.70642 9.16667 9.16666V13.3333C9.16667 13.7936 8.79357 14.1667 8.33333 14.1667C7.8731 14.1667 7.5 13.7936 7.5 13.3333V9.16666C7.5 8.70642 7.8731 8.33332 8.33333 8.33332ZM11.6667 8.33332C12.1269 8.33332 12.5 8.70642 12.5 9.16666V13.3333C12.5 13.7936 12.1269 14.1667 11.6667 14.1667C11.2064 14.1667 10.8333 13.7936 10.8333 13.3333V9.16666C10.8333 8.70642 11.2064 8.33332 11.6667 8.33332Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }